export const environment = {
  production: true,
  apiUrl: "https://umyobizdfw.com/api_umyocards/public/api/"
};


